import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Colors from '../../constants/Colors';
import CloseIconSmall from '../12pxIcons/CloseIconSmall';
import { notificationTypeTitles, progressionTitles, severityTitles } from './NotificationFilter';
import { DateRange } from '../../redux/dateRangeSlice';
import { getNotificationTime } from './data';
import {
  NotificationSeverity, NotificationType, TicketPriority, TicketStatus,
} from '../../constants/Types';
import PressableStyled from '../PressableStyled';
import { isValidValue } from '../../constants/Utils';

interface FilterTagsProps {
  appliedDateFilter: DateRange,
  appliedProgressionFilter: TicketStatus,
  appliedSeverityFilter: NotificationSeverity,
  appliedNotificationTypeFilter: NotificationType,
  appliedPriorityFilter: TicketPriority,
  appliedSearchString: string,
  clearFilterResults: () => void,
  clearSearchResults: () => void,
  clearDateFilter: () => void,
  clearPriorityFilter: () => void,
  clearSeverityFilter: () => void,
  clearNotificationTypeFilter: () => void,
  clearProgressionFilter: () => void,
  slaNames: string[],
}

const FilterTags = ({
  appliedDateFilter, appliedProgressionFilter, appliedSeverityFilter, appliedNotificationTypeFilter,
  appliedPriorityFilter, appliedSearchString, clearFilterResults, clearSearchResults, slaNames,
  clearDateFilter, clearPriorityFilter, clearSeverityFilter, clearNotificationTypeFilter,
  clearProgressionFilter,
}: FilterTagsProps) => <View style={styles.container}>
    {(appliedDateFilter?.start || appliedDateFilter?.end || appliedProgressionFilter
      || isValidValue(appliedSeverityFilter, NotificationSeverity)
      || appliedNotificationTypeFilter || isValidValue(appliedPriorityFilter, TicketPriority))
      ? <PressableStyled onPress={clearFilterResults}>
        <Text style={styles.clearFiltersText}>{'CLEAR ALL FILTERS'}</Text>
      </PressableStyled> : null}
    {appliedSearchString?.length > 0 && <View
      style={styles.item}
      testID='filter-label'
    >
      <Text style={styles.text}>
        {`Searching for: ${appliedSearchString}`}
      </Text>
      <PressableStyled onPress={clearSearchResults}>
        <CloseIconSmall />
      </PressableStyled>
    </View>}
    {appliedDateFilter?.start && <View
      style={styles.item}
      testID='filter-label'
    >
      <Text style={styles.text}>
        {`Date: ${getNotificationTime(appliedDateFilter.start.toString())} to `}
        {`${getNotificationTime(appliedDateFilter.end.toString())}`}
      </Text>
      <PressableStyled onPress={clearDateFilter}>
        <CloseIconSmall />
      </PressableStyled>
    </View>}
    {isValidValue(appliedPriorityFilter, TicketPriority) && <View
      style={styles.item}
      testID='filter-label'
    >
      <Text style={styles.text}>
        {`Priority: P${appliedPriorityFilter + 1} - ${slaNames[appliedPriorityFilter]}`}
      </Text>
      <PressableStyled onPress={clearPriorityFilter}>
        <CloseIconSmall />
      </PressableStyled>
    </View>}
    {isValidValue(appliedSeverityFilter, NotificationSeverity) && <View
      style={styles.item}
      testID='filter-label'
    >
      <Text style={styles.text}>
        {`Severity: ${severityTitles[appliedSeverityFilter]}`}
      </Text>
      <PressableStyled onPress={clearSeverityFilter}>
        <CloseIconSmall />
      </PressableStyled>
    </View>}
    {!!appliedNotificationTypeFilter && <View
      style={styles.item}
      testID='filter-label'
    >
      <Text style={styles.text}>
        {`Notification Type: ${notificationTypeTitles[appliedNotificationTypeFilter]}`}
      </Text>
      <PressableStyled onPress={clearNotificationTypeFilter}>
        <CloseIconSmall />
      </PressableStyled>
    </View>}
    {!!appliedProgressionFilter && <View
      style={styles.item}
      testID='filter-label'
    >
      <Text style={styles.text}>
        {`Progression: ${progressionTitles[appliedProgressionFilter]}`}
      </Text>
      <PressableStyled onPress={clearProgressionFilter}>
        <CloseIconSmall />
      </PressableStyled>
    </View>}
  </View>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    paddingHorizontal: 24,
    paddingBottom: 8,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite100,
    paddingHorizontal: 8,
    marginStart: 8,
    borderRadius: 4,
    marginVertical: 2,
  },
  text: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack400,
    marginEnd: 8,
  },
  clearFiltersText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
    textDecorationLine: 'underline',
  },
});

export default FilterTags;
